// 结构页面
import React, { useRef, useState, useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { Layout, App, Input, Form, Button, theme, Dropdown, Spin, Drawer } from 'antd';
import Menu from './menu'
import Logo from '@/common/img/logo.svg'
import { MenuList } from './menu_list.js';
import { universalGetUserInfo, SetPassword } from '@/server/login'

function Structure () {
  const navigate = useNavigate()
  const [collapsed, setCollapsed] = useState(false)
  const { Header, Sider, Content } = Layout;
  const {
    token: { colorBgContainer, colorText },
  } = theme.useToken(); //获取主题颜色
  const { message } = App.useApp();
  const token = localStorage.getItem('dock_token');
  const isAvoidLogin = localStorage.getItem('dock_isAvoidLogin') || 0;
  const [user_info, setUserInfo] = useState({});
  const [editPasswordList, setEditPasswordList] = useState({//修改密码  抽屉
    isOpen: false,
    loading: false,
    newPassword: '',//新密码
    confirmPassword: '',//确认新密码
  })
  const form = useRef();

  const items = [
    {
      label: '修改密码',
      key: '1',
    },
    {
      label: '退出登录',
      key: '2',
    },
  ];

  //获取用户信息
  const GetUserInfoFun = async () => {
    const res = await universalGetUserInfo({
      access_token: token,
    });
    if (res.ret === 200) { // eslint-disable-line
      setUserInfo(res.data.profile);
      localStorage.setItem('dock_CompanyID', res.data.profile.CompanyID);
      localStorage.setItem('dock_companyType', res.data.profile.company_type);// 1：m3(M3Drone)   2：m30(Air)
    } else {
      message.warning(res.msg || '获取用户信息失败，请稍后重试！！！')
    }
  }

  const onHead = ({ key }) => {
    if (key === '1') {
      // localStorage.setItem('dock_menuKey', '/ChangePassword');
      // navigate('/ChangePassword', { replace: true });

      let edi = editPasswordList
      edi.isOpen = true
      edi.newPassword = ''
      edi.confirmPassword = ''
      setEditPasswordList({ ...edi })
      return;
    }


    if (key === '2') {
      message.success('退出成功');
      setTimeout(() => {
        navigate('/login', { replace: true });
      }, 1500)
    }
  };


  const onFinish = async (values) => {//提交修改密码
    let edi = editPasswordList
    edi.loading = true
    setEditPasswordList({ ...edi })
    let res = await SetPassword({
      access_token: token,
      password: values.old_password,
      new_password: values.new_password
    })

    if (res.ret === 200) {
      if (res.data.is_alter) {
        message.success('修改密码成功，即将返回登陆页面');
        edi.isOpen = false
        edi.loading = false
        setEditPasswordList({ ...edi })
        setTimeout(() => {
          navigate('/login')
        }, 1500)
      } else {
        message.error('修改密码失败');
        edi.loading = false
        setEditPasswordList({ ...edi })
      }
    } else {
      edi.loading = false
      setEditPasswordList({ ...edi })
    }

  }


  const pwdValidator = (rule, value, callback) => {//校验  密码
    if (!value) {
      return callback('请再次输入新密码')
    } else if (value !== editPasswordList.newPassword) {
      return callback('两次密码不相同请重新输入')
    } else {
      return callback()
    }
  }

  useEffect(() => {
    GetUserInfoFun()
    // eslint-disable-next-line
  }, [])

  return (
    <Layout className='box' style={{ height: '100vh' }}>
      {/* 头部 */}
      <Header style={{ padding: '0', background: '#171717', height: 48 }}>
        <div className='pdRL16 flex jcsb align_center' style={{ height: '100%' }}>

          {/* 系统名 */}
          <div className="flex_row align_center">
            <img src={Logo} alt='logo' className="w28 h28 marR12" />
            <font className="fs18 col_main_text">{user_info.project_name}</font>
          </div>


          {/* 公司名称 */}
          <div className="col_main_text pdRL12">
            <font className="marR8 col_main_text">{user_info.cominfo_name || '公司名'}</font>
            {
              isAvoidLogin ? <span className='opa85'>{user_info.username}</span> :
                <Dropdown menu={{
                  items,
                  onClick: onHead
                }}>
                  <span className='pointer opa85'>{user_info.username}</span>
                </Dropdown>
            }

          </div>
        </div>
      </Header>


      <Layout>
        {/* 菜单 */}
        <Sider style={{ overflowY: 'auto', background: colorBgContainer }}>
          {
            localStorage.getItem('dock_companyType') &&
            <Menu
              menuList={MenuList}
              collapsed={collapsed}
              setCollapsed={setCollapsed}
            >
            </Menu>}
        </Sider>

        {/* 内容 */}
        <Content style={{ overflow: 'auto' }}>
          {
            localStorage.getItem('dock_companyType') && <Outlet />
          }
        </Content>
      </Layout>



      {/* 抽屉 */}
      <Drawer
        width={256}
        title='修改密码'
        onClose={() => {
          let edi = editPasswordList
          edi.isOpen = false
          setEditPasswordList({ ...edi })
        }}
        open={editPasswordList.isOpen}
        extra={
          <Button
            type='primary'
            onClick={() => {
              document.getElementById('submit').click()
            }}
          >
            确定
          </Button>
        }
      >

        <Spin spinning={editPasswordList.loading}>
          <Form
            ref={form}
            name="basic"
            layout='vertical'
            style={{ color: '#fff !import' }}
            onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item
              label="原密码"
              name="old_password"
              rules={[
                {
                  required: true,
                  message: '请输入原密码',
                }
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="新密码"
              name="new_password"
              validateTrigger="onBlur"
              rules={[
                {
                  required: true,
                  message: '请输入新密码',
                },
                {
                  // pattern: /^\S*(?=\S{12,})(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])(?=\S*[!@#$%^&*-_? ])\S*$/,
                  pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d]).{12,}$/,
                  message: '密码不低于12位，且包含大小写英文、数字、符号'
                }
              ]}
            >
              <Input.Password
                value={editPasswordList.newPassword}
                onChange={(value) => {
                  let edi = editPasswordList
                  edi.newPassword = value.target.value
                  setEditPasswordList({ ...edi })
                }}
              />
            </Form.Item>

            <Form.Item
              label="确认密码"
              name="confirm_password"
              validateTrigger="onBlur"
              required
              rules={[
                {
                  validator: pwdValidator,
                }
              ]}
            >
              <Input.Password
                value={editPasswordList.confirmPassword}
                onChange={(value) => {
                  let edi = editPasswordList
                  edi.confirmPassword = value.target.value
                  setEditPasswordList({ ...edi })
                }} />
            </Form.Item>

            <Form.Item
              wrapperCol={{
                offset: 8,
                span: 16,
              }}
            >
              <Button
                id='submit'
                type="primary"
                className='none'
                htmlType="submit"
              >
                提交
              </Button>
            </Form.Item>
          </Form>

        </Spin>
      </Drawer>
    </Layout>




  )
}
export default Structure